<nav [ngClass]="'sidebar ' + extendShopifyDesign">
  <a [ngClass]="'sd-tgl-btn ' + extendShopifyDesign " href="javascript:void(0);">
    <span></span>
    <span></span>
    <span></span>
  </a>
  <div class="sidebar-header text-center">
    <a [routerLink]="['/store/dashboard']">
      <img src="assets/img/MerchLoop-Iconwithtext-p-500.png" width="100" />
    </a>
  </div>
  <div [ngClass]="'dash-avt-wrp '  + extendShopifyDesign">
    <div class="background-dash-avt-wrap">
      <div class="dash-avt">
        <img id="file-image" [src]="ProfileimageSrc || 'assets/img/default_user_img.png'" alt="dashboard">
        <!-- <img src="assets/img/default_user_img.png" > -->
      </div>
      <div class="dash-content">
        <h4>
          {{FullName.length>15 ? (FullName | slice:0:15)+'...':(FullName) }}
        </h4>
      </div>
    </div>
  </div>
  <ul class="" [ngClass]="'list-unstyled components ' + extendShopifyDesign" >
    <li  class="sidebarLink" >
      <a [routerLink]="['/store/dashboard']" [routerLinkActive]="['active-link']">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1"
          x="0px" y="0px" viewBox="0 0 27.02 27.02" style="enable-background:new 0 0 27.02 27.02;" xml:space="preserve"
          width="16">
          <g>
            <path
              d="M3.674,24.876c0,0-0.024,0.604,0.566,0.604c0.734,0,6.811-0.008,6.811-0.008l0.01-5.581   c0,0-0.096-0.92,0.797-0.92h2.826c1.056,0,0.991,0.92,0.991,0.92l-0.012,5.563c0,0,5.762,0,6.667,0   c0.749,0,0.715-0.752,0.715-0.752V14.413l-9.396-8.358l-9.975,8.358C3.674,14.413,3.674,24.876,3.674,24.876z"
              fill="#FFFFFF" />
            <path
              d="M0,13.635c0,0,0.847,1.561,2.694,0l11.038-9.338l10.349,9.28c2.138,1.542,2.939,0,2.939,0   L13.732,1.54L0,13.635z"
              fill="#FFFFFF" />
            <polygon points="23.83,4.275 21.168,4.275 21.179,7.503 23.83,9.752  " fill="#FFFFFF" />
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g>
          </g>
          <g></g>
          <g></g>
        </svg>
        Dashboard
      </a>
    </li>
    <li  class="sidebarLink" *ngIf="hasPermission('StoreGallery')">
      <a [routerLink]="['/store/list']" [routerLinkActive]="['active-link']">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1"
          x="0px" y="0px" viewBox="0 0 489.4 489.4" style="enable-background:new 0 0 489.4 489.4;" xml:space="preserve"
          width="16">
          <g>
            <g>
              <path
                d="M347.7,263.75h-66.5c-18.2,0-33,14.8-33,33v51c0,18.2,14.8,33,33,33h66.5c18.2,0,33-14.8,33-33v-51    C380.7,278.55,365.9,263.75,347.7,263.75z M356.7,347.75c0,5-4.1,9-9,9h-66.5c-5,0-9-4.1-9-9v-51c0-5,4.1-9,9-9h66.5    c5,0,9,4.1,9,9V347.75z"
                fill="#FFFFFF" />
              <path
                d="M489.4,171.05c0-2.1-0.5-4.1-1.6-5.9l-72.8-128c-2.1-3.7-6.1-6.1-10.4-6.1H84.7c-4.3,0-8.3,2.3-10.4,6.1l-72.7,128    c-1,1.8-1.6,3.8-1.6,5.9c0,28.7,17.3,53.3,42,64.2v211.1c0,6.6,5.4,12,12,12h66.3c0.1,0,0.2,0,0.3,0h93c0.1,0,0.2,0,0.3,0h221.4    c6.6,0,12-5.4,12-12v-209.6c0-0.5,0-0.9-0.1-1.3C472,224.55,489.4,199.85,489.4,171.05z M91.7,55.15h305.9l56.9,100.1H34.9    L91.7,55.15z M348.3,179.15c-3.8,21.6-22.7,38-45.4,38c-22.7,0-41.6-16.4-45.4-38H348.3z M232,179.15c-3.8,21.6-22.7,38-45.4,38    s-41.6-16.4-45.5-38H232z M24.8,179.15h90.9c-3.8,21.6-22.8,38-45.5,38C47.5,217.25,28.6,200.75,24.8,179.15z M201.6,434.35h-69    v-129.5c0-9.4,7.6-17.1,17.1-17.1h34.9c9.4,0,17.1,7.6,17.1,17.1v129.5H201.6z M423.3,434.35H225.6v-129.5    c0-22.6-18.4-41.1-41.1-41.1h-34.9c-22.6,0-41.1,18.4-41.1,41.1v129.6H66v-193.3c1.4,0.1,2.8,0.1,4.2,0.1    c24.2,0,45.6-12.3,58.2-31c12.6,18.7,34,31,58.2,31s45.5-12.3,58.2-31c12.6,18.7,34,31,58.1,31c24.2,0,45.5-12.3,58.1-31    c12.6,18.7,34,31,58.2,31c1.4,0,2.7-0.1,4.1-0.1L423.3,434.35L423.3,434.35z M419.2,217.25c-22.7,0-41.6-16.4-45.4-38h90.9    C460.8,200.75,441.9,217.25,419.2,217.25z"
                fill="#FFFFFF" />
            </g>
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
        Store Gallery
      </a>
    </li>
    <li  class="sidebarLink" *ngIf="hasPermission('Product')">
      <a class="test">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1"
          x="0px" y="0px" width="16" viewBox="0 0 612 612" style="enable-background:new 0 0 612 612;"
          xml:space="preserve">
          <g>
            <path
              d="M1.659,484.737L1.001,206.595c-0.032-13.686,13.95-22.938,26.534-17.559l253.206,108.241   c6.997,2.991,11.542,9.859,11.56,17.468l0.658,278.142c0.032,13.687-13.95,22.939-26.534,17.56L13.219,502.206   C6.222,499.215,1.676,492.347,1.659,484.737z M581.805,219.687L348.142,320.883l0.608,257.406l233.664-101.196L581.805,219.687    M591.26,186.131c10.043-0.025,19.056,8.054,19.081,19.022l0.658,278.142c0.018,7.609-4.495,14.5-11.478,17.523l-252.69,109.438   c-2.493,1.079-5.047,1.583-7.534,1.59c-10.044,0.023-19.058-8.055-19.083-19.022l-0.658-278.143   c-0.019-7.609,4.495-14.5,11.479-17.523l252.69-109.437C586.218,186.64,588.771,186.137,591.26,186.131L591.26,186.131z    M304.152,29.466L61.767,137.691l242.894,107.075l242.386-108.224L304.152,29.466 M304.083,0c2.632-0.006,5.266,0.533,7.728,1.618   l266.403,117.439c15.112,6.663,15.163,28.088,0.082,34.821L312.451,272.577c-2.456,1.097-5.088,1.648-7.721,1.655   c-2.632,0.006-5.266-0.533-7.728-1.618L30.6,155.175c-15.113-6.662-15.163-28.088-0.083-34.821L296.361,1.655   C298.818,0.558,301.449,0.006,304.083,0L304.083,0z"
              fill="#FFFFFF" />
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g>
          </g>
          <g></g>
        </svg>
        Product
        <i class="fa fa-angle-right" style="float: right;" aria-hidden="true"></i>
      </a>
      <ul [ngClass]="'sb-drpdwn ' + extendShopifyDesign ">
        <li  class="sidebarLink" *ngIf="hasPermission('ProductCatalog')">
          <a [routerLink]="[ '/store/upload-design']" [routerLinkActive]="['active-link']">
            Product Catalog
          </a>
        </li>
        <li class="sidebarLink" *ngIf="hasPermission('ProductLibrary')">
          <a [routerLink]="['/store/customizedproducts']" [routerLinkActive]="['active-link']">
            Product Library
          </a>
        </li>
        <li class="sidebarLink" *ngIf="hasPermission('PublishedProduct')">
          <a [routerLink]="['/store/publishedproducts']" [routerLinkActive]="['active-link']">
            Published Product
          </a>
        </li>
      </ul>
    </li>

    <li  class="sidebarLink" *ngIf="hasPermission('Commission')">
      <a [routerLink]="[ '/store/commissions']" [routerLinkActive]="['active-link']">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1"
          x="0px" y="0px" width="17" height="17" viewBox="0 0 511.613 511.613"
          style="enable-background:new 0 0 511.613 511.613;" xml:space="preserve">
          <g>
            <path
              d="M385.261,311.475c-2.471-8.367-5.469-15.649-8.99-21.833c-3.519-6.19-8.559-12.228-15.13-18.134   c-6.563-5.903-12.467-10.657-17.702-14.271c-5.232-3.617-12.419-7.661-21.557-12.137c-9.13-4.475-16.364-7.805-21.689-9.995   c-5.332-2.187-13.045-5.185-23.134-8.992c-8.945-3.424-15.605-6.042-19.987-7.849c-4.377-1.809-10.133-4.377-17.271-7.71   c-7.135-3.328-12.465-6.28-15.987-8.848c-3.521-2.568-7.279-5.708-11.277-9.419c-3.998-3.711-6.805-7.661-8.424-11.848   c-1.615-4.188-2.425-8.757-2.425-13.706c0-12.94,5.708-23.507,17.128-31.689c11.421-8.182,26.174-12.275,44.257-12.275   c7.99,0,16.136,1.093,24.41,3.284s15.365,4.659,21.266,7.421c5.906,2.762,11.471,5.808,16.707,9.137   c5.235,3.332,8.945,5.852,11.136,7.565c2.189,1.714,3.576,2.855,4.141,3.427c2.478,1.903,5.041,2.568,7.706,1.999   c2.854-0.19,5.045-1.715,6.571-4.567l23.13-41.684c2.283-3.805,1.811-7.422-1.427-10.85c-1.144-1.142-2.566-2.473-4.291-3.997   c-1.708-1.524-5.421-4.283-11.136-8.282c-5.709-3.996-11.752-7.565-18.124-10.706c-6.379-3.138-14.661-6.328-24.845-9.562   c-10.178-3.239-20.697-5.426-31.549-6.567V9.136c0-2.663-0.855-4.853-2.563-6.567C282.493,0.859,280.303,0,277.634,0h-38.546   c-2.474,0-4.615,0.903-6.423,2.712s-2.712,3.949-2.712,6.424v51.391c-29.884,5.708-54.152,18.461-72.805,38.256   c-18.651,19.796-27.98,42.823-27.98,69.092c0,7.803,0.812,15.226,2.43,22.265c1.616,7.045,3.616,13.374,5.996,18.988   c2.378,5.618,5.758,11.136,10.135,16.562c4.377,5.424,8.518,10.088,12.419,13.988c3.903,3.899,8.995,7.945,15.274,12.131   c6.283,4.19,11.66,7.571,16.134,10.139c4.475,2.56,10.422,5.52,17.843,8.843c7.423,3.333,13.278,5.852,17.561,7.569   c4.283,1.711,10.135,4.093,17.561,7.132c10.277,3.997,17.892,7.091,22.84,9.281c4.952,2.19,11.231,5.235,18.849,9.137   c7.611,3.898,13.176,7.468,16.7,10.705c3.521,3.237,6.708,7.234,9.565,11.991s4.288,9.801,4.288,15.133   c0,15.037-5.853,26.645-17.562,34.823c-11.704,8.187-25.27,12.279-40.685,12.279c-7.036,0-14.084-0.757-21.124-2.279   c-24.744-4.955-47.869-16.851-69.377-35.693l-0.571-0.571c-1.714-2.088-3.999-2.946-6.851-2.563   c-3.046,0.38-5.236,1.523-6.567,3.43l-29.408,38.54c-2.856,3.806-2.663,7.707,0.572,11.704c0.953,1.143,2.618,2.86,4.996,5.14   c2.384,2.289,6.81,5.852,13.278,10.715c6.47,4.856,13.513,9.418,21.128,13.706c7.614,4.281,17.272,8.514,28.98,12.703   c11.708,4.182,23.839,7.131,36.402,8.843v49.963c0,2.478,0.905,4.617,2.712,6.427c1.809,1.811,3.949,2.711,6.423,2.711h38.546   c2.669,0,4.859-0.855,6.57-2.566s2.563-3.901,2.563-6.571v-49.963c30.269-4.948,54.87-17.939,73.806-38.972   c18.938-21.033,28.41-46.11,28.41-75.229C388.994,328.801,387.759,319.855,385.261,311.475z"
              fill="#FFFFFF" />
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
        Commission
      </a>
    </li>
     <li  class="sidebarLink">
    <a>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" aria-labelledby="title" aria-describedby="desc"
           role="img" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Home Folder</title>
        <desc>A line styled icon from Orion Icon Library.</desc>
        <path data-name="layer2" d="M54 33V15H22V9H2v40.3A1.7 1.7 0 0 0 3.7 51H34" fill="none" stroke="#ffffff"
              stroke-miterlimit="10" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"></path>
        <path data-name="layer1" fill="none" stroke="#ffffff" stroke-miterlimit="10" stroke-width="4"
              d="M30 41l16-16 16 16" stroke-linejoin="round" stroke-linecap="round"></path>
        <path data-name="layer1" fill="none" stroke="#ffffff" stroke-miterlimit="10" stroke-width="4"
              d="M34 37v20h24V37" stroke-linejoin="round" stroke-linecap="round"></path>
        <path data-name="layer1" fill="none" stroke="#ffffff" stroke-miterlimit="10" stroke-width="4" d="M42 57V45h8"
              stroke-linejoin="round" stroke-linecap="round"></path>
      </svg>
      Warehouse
      <i class="fa fa-angle-right" style="float: right;" aria-hidden="true"></i>
    </a>
    <ul [ngClass]="'sb-drpdwn ' + extendShopifyDesign ">
      <li  class="sidebarLink">
        <a [routerLink]="[ '/store/productlisting']" [routerLinkActive]="['active-link']">
          Product Listing
        </a>
      </li>
      <li  class="sidebarLink">
        <a [routerLink]="['/store/warehouse-inventory-holding-payments']" [routerLinkActive]="['active-link']">
          Inventory Holding Payments
        </a>
      </li>
    </ul>
  </li> 
    <li class="sidebarLink" *ngIf="hasPermission('TrackOrders')">
      <a [routerLink]="[ '/store/report/orders']" [routerLinkActive]="['active-link']">
        <svg xmlns="http://www.w3.org/2000/svg" height="17px" viewBox="0 -4 392.00617 392" width="17px">
          <path
            d="m360.007812 160.011719h-48c-17.648437 0-32 14.355469-32 32v160h-24v-112c0-17.644531-14.355468-32-32-32h-48c-17.648437 0-32 14.355469-32 32v112h-24v-64c0-17.644531-14.355468-32-32-32h-48c-17.648437 0-32 14.355469-32 32v80c0 8.832031 7.167969 16 16 16h352c8.832032 0 16-7.167969 16-16v-176c0-17.644531-14.355468-32-32-32zm-320 192-.019531-64h48.019531v64zm136 0-.019531-112h48.019531v112zm136 0-.027343-160h48.027343v160zm0 0"
            fill="#FFFFFF" />
          <path
            d="m383.8125 45.710938c-.039062-.273438-.117188-.523438-.175781-.785157-.207031-1.039062-.511719-2.046875-.917969-3.015625-.136719-.335937-.265625-.65625-.425781-.976562-.574219-1.160156-1.238281-2.265625-2.078125-3.257813-.039063-.046875-.097656-.085937-.136719-.132812-.824219-.953125-1.785156-1.769531-2.824219-2.515625-.136718-.09375-.230468-.230469-.367187-.324219l-48-32c-7.359375-4.921875-17.289063-2.921875-22.183594 4.4375-4.898437 7.351563-2.914063 17.289063 4.4375 22.183594l21.691406 14.457031-322.296875 117.199219c-8.304687 3.015625-12.585937 12.199219-9.570312 20.503906 2.371094 6.496094 8.503906 10.527344 15.042968 10.527344 1.8125 0 3.664063-.308594 5.46875-.964844l322.539063-117.289063-7.386719 25.855469c-2.429687 8.496094 2.496094 17.351563 10.984375 19.777344 1.464844.429687 2.945313.621094 4.402344.621094 6.957031 0 13.367187-4.582031 15.375-11.605469l16-56c.175781-.617188.230469-1.234375.335937-1.855469.03125-.21875.144532-.410156.167969-.632812.007813-.089844-.015625-.175781-.007812-.265625.136719-1.335938.113281-2.648438-.074219-3.941406zm0 0"
            fill="#FFFFFF" />
        </svg>
        Track Orders
      </a>
    </li>
    <li  class="sidebarLink" *ngIf="hasPermission('InvoiceDetails')">
      <a [routerLink]="[ '/store/invoice-list']" [routerLinkActive]="['active-link']">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" height="17px" viewBox="0 -4 392.00617 392" width="17px"><path d="m360.007812 160.011719h-48c-17.648437 0-32 14.355469-32 32v160h-24v-112c0-17.644531-14.355468-32-32-32h-48c-17.648437 0-32 14.355469-32 32v112h-24v-64c0-17.644531-14.355468-32-32-32h-48c-17.648437 0-32 14.355469-32 32v80c0 8.832031 7.167969 16 16 16h352c8.832032 0 16-7.167969 16-16v-176c0-17.644531-14.355468-32-32-32zm-320 192-.019531-64h48.019531v64zm136 0-.019531-112h48.019531v112zm136 0-.027343-160h48.027343v160zm0 0" fill="#FFFFFF" /><path d="m383.8125 45.710938c-.039062-.273438-.117188-.523438-.175781-.785157-.207031-1.039062-.511719-2.046875-.917969-3.015625-.136719-.335937-.265625-.65625-.425781-.976562-.574219-1.160156-1.238281-2.265625-2.078125-3.257813-.039063-.046875-.097656-.085937-.136719-.132812-.824219-.953125-1.785156-1.769531-2.824219-2.515625-.136718-.09375-.230468-.230469-.367187-.324219l-48-32c-7.359375-4.921875-17.289063-2.921875-22.183594 4.4375-4.898437 7.351563-2.914063 17.289063 4.4375 22.183594l21.691406 14.457031-322.296875 117.199219c-8.304687 3.015625-12.585937 12.199219-9.570312 20.503906 2.371094 6.496094 8.503906 10.527344 15.042968 10.527344 1.8125 0 3.664063-.308594 5.46875-.964844l322.539063-117.289063-7.386719 25.855469c-2.429687 8.496094 2.496094 17.351563 10.984375 19.777344 1.464844.429687 2.945313.621094 4.402344.621094 6.957031 0 13.367187-4.582031 15.375-11.605469l16-56c.175781-.617188.230469-1.234375.335937-1.855469.03125-.21875.144532-.410156.167969-.632812.007813-.089844-.015625-.175781-.007812-.265625.136719-1.335938.113281-2.648438-.074219-3.941406zm0 0" fill="#FFFFFF" /></svg>-->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" aria-labelledby="title" aria-describedby="desc"
          role="img" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>Purchase Order</title>
          <desc>A line styled icon from Orion Icon Library.</desc>
          <path data-name="layer2" d="M16 48V8a6 6 0 0 1 6-6h34" fill="none" stroke="#ffffff" stroke-miterlimit="10"
            stroke-width="2" stroke-linejoin="round" stroke-linecap="round"></path>
          <path data-name="layer2"
            d="M50 12h12V8a6 6 0 0 0-6-6 6 6 0 0 0-6 6v44a10 10 0 0 1-10 10 10 10 0 0 1-10-10v-4H2v4a10 10 0 0 0 10 10h28"
            fill="none" stroke="#ffffff" stroke-miterlimit="10" stroke-width="2" stroke-linejoin="round"
            stroke-linecap="round"></path>
          <path data-name="layer1" fill="none" stroke="#ffffff" stroke-miterlimit="10" stroke-width="2"
            d="M24 12h16M24 28h16m-16-8h12M24 36h12" stroke-linejoin="round" stroke-linecap="round"></path>
        </svg>
        Invoice Details
      </a>
    </li>
    <li  class="sidebarLink" *ngIf="hasPermission('PendingPayments')">
      <a [routerLink]="[ '/store/viewemdproduct']" [routerLinkActive]="['active-link']">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" aria-labelledby="title" aria-describedby="desc"
          role="img" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>Bank Cards</title>
          <desc>A line styled icon from Orion Icon Library.</desc>
          <path data-name="layer2"
            d="M10.3 29l-2.2-6.1a2.4 2.4 0 0 1 1.4-3.1L50.1 5.1a2.4 2.4 0 0 1 3.1 1.4l8.7 24a2.4 2.4 0 0 1-1.4 3.1L50 37.4m-39.9-9.2L55 11.8m-8.3 9.8l4.5-1.6"
            fill="none" stroke="#ffffff" stroke-miterlimit="10" stroke-width="2" stroke-linejoin="round"
            stroke-linecap="round"></path>
          <rect data-name="layer1" x="2" y="29" width="48" height="30" rx="2.4" ry="2.4" fill="none" stroke="#ffffff"
            stroke-miterlimit="10" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"></rect>
          <path data-name="layer1" fill="none" stroke="#ffffff" stroke-miterlimit="10" stroke-width="2"
            d="M10 43h14m12-6h6M10 51h2m8 0h2m8 0h2m8 0h2" stroke-linejoin="round" stroke-linecap="round"></path>
        </svg>

        Pending Payments
      </a>
    </li>
    <li  class="sidebarLink" *ngIf="hasPermission('ReportABug')">
      <a [routerLink]="[ '/store/report-bug']" [routerLinkActive]="['active-link']">
        <svg xmlns="http://www.w3.org/2000/svg" height="17px" viewBox="0 0 96 96" width="17px">
          <path
            d="M82.2422,67.7578A5.9956,5.9956,0,0,0,78,66H72V62.4844l6-6,7.7578,7.7578a5.9994,5.9994,0,0,0,8.4844-8.4844l-12-12a5.9979,5.9979,0,0,0-8.4844,0L72,45.5156V42a23.7864,23.7864,0,0,0-5.915-15.6006L76.2422,16.2422a5.9994,5.9994,0,0,0-8.4844-8.4844L56.031,19.4846a22.4643,22.4643,0,0,0-16.062,0L28.2422,7.7578a5.9994,5.9994,0,0,0-8.4844,8.4844L29.915,26.3994A23.7864,23.7864,0,0,0,24,42v3.5156l-1.7578-1.7578a5.9979,5.9979,0,0,0-8.4844,0l-12,12a5.9994,5.9994,0,0,0,8.4844,8.4844L18,56.4844l6,6V66H18a5.9958,5.9958,0,0,0-4.2422,1.7578l-12,12a5.9994,5.9994,0,1,0,8.4844,8.4844L20.4844,78H27.34a23.7852,23.7852,0,0,0,41.32,0h6.8554L85.7578,88.2422a5.9994,5.9994,0,0,0,8.4844-8.4844ZM60,42H36a12,12,0,0,1,24,0ZM48,78A12.0081,12.0081,0,0,1,36,66V54H60V66A12.0081,12.0081,0,0,1,48,78Z"
            fill="#FFFFFF" />
        </svg>
        Report a Bug
      </a>
    </li>
    <li  class="sidebarLink" *ngIf="hasPermission('RequestAColor')">
      <a [routerLink]="[ '/store/request-color']" [routerLinkActive]="['active-link']">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-palette"
          viewBox="0 0 16 16">
          <path
            d="M8 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm4 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM5.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
          <path
            d="M16 8c0 3.15-1.866 2.585-3.567 2.07C11.42 9.763 10.465 9.473 10 10c-.603.683-.475 1.819-.351 2.92C9.826 14.495 9.996 16 8 16a8 8 0 1 1 8-8zm-8 7c.611 0 .654-.171.655-.176.078-.146.124-.464.07-1.119-.014-.168-.037-.37-.061-.591-.052-.464-.112-1.005-.118-1.462-.01-.707.083-1.61.704-2.314.369-.417.845-.578 1.272-.618.404-.038.812.026 1.16.104.343.077.702.186 1.025.284l.028.008c.346.105.658.199.953.266.653.148.904.083.991.024C14.717 9.38 15 9.161 15 8a7 7 0 1 0-7 7z" />
        </svg>
        Request a Color
      </a>
    </li>
    <li  class="sidebarLink" *ngIf="hasPermission('Team')">
      <a [routerLink]="[ '/store/team']" [routerLinkActive]="['active-link']">
        <i class="fa fa-group"></i>
        Team
      </a>
    </li>
    <li  class="sidebarLink" *ngIf="hasPermission('Setting')">
      <a [routerLink]="[ '/store/setting']" [routerLinkActive]="['active-link']">
        <i class="fa fa-cog"></i>
        Setting
      </a>
    </li>
  </ul>
</nav>